export default __webpack_public_path__ + "static/media/36_mobile.11818494.jpg";